import { Modal } from "components";
import RequiredNumberInput from "components/ValidatedFields/RequiredNumberInput";
import OptionalTextInput from "components/ValidatedFields/OptionalTextInput";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";
import { EditSectionTemplate } from "components/MainSectionTemplate/EditSectionTemplate";
import React from "react";

interface Props {
  clientId: number;
  onClose: () => void;
}

interface AddCreditFormState {
  amount: number;
  expiresInMonths: number;
  reason: string;
}

const expiresInMonthsOptions: Array<{ value: number, text: string }> = [
  { value: 1, text: "1 month" },
  { value: 3, text: "3 months" },
  { value: 6, text: "6 months" },
  { value: 12, text: "12 months" },
];

export const AddCreditModal = (props: Props) => {
  const [formState, setFormState] = React.useState<AddCreditFormState>({
    amount: serverReference.constants.credit.defaultPromoAmount,
    expiresInMonths: serverReference.constants.credit.defaultPromoExpiresInMonths,
    reason: "",
  });

  const onChange = (newData: Partial<AddCreditFormState>) => {
    setFormState((prevState) => ({
      ...prevState,
      ...newData,
    }));
  };

  const submit = () => {
    return window.CoreApi.Credit.AddPromoCredits({
      clientId: props.clientId,
      amount: formState.amount,
      reason: formState.reason,
      expiresInMonths: formState.expiresInMonths,
    });
  };

  const onSuccess = () => {
    props.onClose();
  };

  return <Modal
    isOpen
    handleClose={props.onClose}
    title="Add promo credit"
    width="tiny"
  >
    <div className="grow1 scrollbox-auto">
      <EditSectionTemplate
        submit={submit}
        noPanels
        onSuccess={onSuccess}
        sections={[{
          key: "creditDetails",
          type: "regular",
          title: "Add promo credit",
          fields: [{
            key: "amount",
            label: "Amount",
            renderEditNew: () => <RequiredNumberInput
              minValue={serverReference.constants.credit.minPromoAmount}
              maxValue={serverReference.constants.credit.maxPromoAmount}
              value={formState.amount}
              onChange={(amount: number) => onChange({ amount })}
              decimalPoints={0}
              canBeEmpty={false}
              canBeNegative={false}
              validatorKey="amount"
              width={75}
              labelContent="EUR"
            />
          }, {
            key: "expiresInMonths",
            label: "Expires in",
            renderEditNew: () => {
              const selected = expiresInMonthsOptions.find(o => o.value === formState.expiresInMonths);
              return <BaseReactSelectDropdown
                options={expiresInMonthsOptions}
                value={selected}
                onChange={(v) => onChange({ expiresInMonths: v.value })}
                getLabel={o => o.text}
                getValue={o => o.value}
                excludeKeys={[]}
                config={{
                  isSearchable: false,
                  shouldRenderSelectedValue: true,
                }}
              />;
            }
          }, {
            key: "reason",
            label: "Reason",
            renderEditNew: () => <OptionalTextInput
              value={formState.reason}
              onChange={(reason: string) => onChange({ reason })}
              maxLength={serverReference.constants.credit.maxPromoReasonLength}
            />
          }]
        }]}
      />
    </div>
  </Modal>
}
